"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUpload = void 0;
var react_1 = __importDefault(require("react"));
var shared_1 = require("../shared");
var HasFile_1 = require("./HasFile");
var NeedsToReload_1 = require("./NeedsToReload");
var NotReady_1 = require("./NotReady");
var Ready_1 = require("./Ready");
var Uploading_1 = require("./Uploading");
var FileUpload = function (_a) {
    var status = _a.status, color = _a.color, propertyId = _a.propertyId, thumbnail = _a.thumbnail, onFileSelect = _a.onFileSelect, onDelete = _a.onDelete, onFileChange = _a.onFileChange, onReload = _a.onReload, disabled = _a.disabled, _b = _a.displayError, displayError = _b === void 0 ? false : _b, uploadingFileSize = _a.uploadingFileSize, accept = _a.accept;
    switch (status) {
        case shared_1.FILE_UPLOAD_INPUT_STATUS.notReady:
            return react_1.default.createElement(NotReady_1.NotReady, { error: displayError });
        case shared_1.FILE_UPLOAD_INPUT_STATUS.ready:
            return (react_1.default.createElement(Ready_1.Ready, { onFileSelect: onFileSelect, disabled: disabled, propertyId: propertyId, color: color, displayError: displayError, accept: accept }));
        case shared_1.FILE_UPLOAD_INPUT_STATUS.uploading:
        case shared_1.FILE_UPLOAD_INPUT_STATUS.uploadComplete:
            return (react_1.default.createElement(Uploading_1.Uploading, { status: status, propertyId: propertyId, color: color, uploadingFileSize: uploadingFileSize, accept: accept }));
        case shared_1.FILE_UPLOAD_INPUT_STATUS.hasFile:
            return (react_1.default.createElement(HasFile_1.HasFile, { thumbnail: thumbnail, disabled: disabled, onDelete: onDelete, onFileChange: onFileChange, propertyId: propertyId, color: color, displayError: displayError, deleting: false, accept: accept }));
        case shared_1.FILE_UPLOAD_INPUT_STATUS.deleting:
            return (react_1.default.createElement(HasFile_1.HasFile, { thumbnail: thumbnail, disabled: disabled, onDelete: onDelete, onFileChange: onFileChange, propertyId: propertyId, color: color, displayError: displayError, deleting: true, accept: accept }));
        case shared_1.FILE_UPLOAD_INPUT_STATUS.needsToReload:
            return (react_1.default.createElement(NeedsToReload_1.NeedsToReload, { disabled: disabled, displayError: displayError, onReload: onReload }));
    }
};
exports.FileUpload = FileUpload;
